import { render, staticRenderFns } from "./FilesUploadSection.vue?vue&type=template&id=09b96604&scoped=true&"
import script from "./FilesUploadSection.vue?vue&type=script&lang=js&"
export * from "./FilesUploadSection.vue?vue&type=script&lang=js&"
import style0 from "./FilesUploadSection.vue?vue&type=style&index=0&id=09b96604&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b96604",
  null
  
)

export default component.exports